import React from "react"
import { TitleProps } from "react-admin"

const ShareTitle: React.FC<TitleProps> = ({ record }) => {
  return <span>Share {record ? `"${record.display_name}"` : ""}</span>
}

export { ShareTitle }
